<template>
<div v-loading="loading">

  <div class="x-table-query" v-if="config.query !== false || config.selection !== false">
    
    <!-- multi opt -->

    <div class="multi-opt" v-if="config.selection !== false" v-show="multiOpt">
      <div class="multi-opt-wrap">
        <el-button v-for="btn in config.selection" v-if="btn.sub == undefined" :icon="btn.icon" :type="btn.type" @click="clickMultiBtn(btn)">{{btn.text}}</el-button>
        <el-dropdown v-for="btn in config.selection" v-if="btn.sub != undefined" trigger="hover">
          <el-button :type="btn.type">
            {{btn.text}}<i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="subBtn in btn.sub" @click.native="clickMultiBtn(subBtn)">{{subBtn.text}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- query -->

    <el-form :inline="true" :model="queryData" v-if="config.query !== false">
      <el-form-item style="margin-bottom:0px;" v-for="item in config.query.form" :class="{'item-radio': item.type == 'radio'}">
        <el-input
          v-if="item.type == 'input'"
          v-model="queryData[item.id]"
          size="small"
          :placeholder="item.placeholder" 
          style="width:120px;">
        </el-input>

        <el-switch
          v-if="item.type == 'switch'"
          v-model="queryData[item.id]"
          :on-text="item.config.onText"
          :off-text="item.config.offText"
          size="small">
        </el-switch>

        <el-date-picker
          v-if="item.type == 'date'"
          v-model="queryData[item.id]"
          :type="item.config.type"
          :placeholder="item.placeholder"
          size="small"
          style="width:120px;">
        </el-date-picker>

        <el-select
          v-if="item.type == 'select'"
          v-model="queryData[item.id]"
          size="small"
          :placeholder="item.placeholder"
          style="width:120px;">
          <el-option v-for="it in item.data" :label="it.text" :value="it.id"></el-option>
        </el-select>

        <xselect-remote
          v-if="item.type == 'select_remote'"
          v-model="queryData[item.id]"
          size="small"
          :url="item.config.url"
          :text-field="item.config.textField"
          :value-field="item.config.valueField"
          :default-item="queryData[item.id]"
          :placeholder="item.placeholder">
        </xselect-remote>

        <el-radio-group v-if="item.type == 'radio'" v-model="queryData[item.id]" size="small" @change="getData">
          <el-radio-button v-for="it in item.data" :label="it.id">{{it.text}}</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item style="margin-bottom:0px;">
        <el-button type="primary" size="small" icon="search" @click="getData">查询</el-button>
      </el-form-item>
    </el-form>

  </div>

  <el-table
    :data="tableData"
    style="width: 100%"
    :height="tableHeight"
    @selection-change="selectionChange" 
    @sort-change="sortTable">

    <!-- selection -->

    <el-table-column type="selection" width="55" v-if="config.selection !== false">
    </el-table-column>

    <!-- expand -->

    <el-table-column type="expand" v-if="config.expand !== false">
      <template scope="props">
        <div class="x-table-expand" :style="{paddingRight: config.rowBtns.config.width + 'px'}">
          <div class="item" v-for="item in config.expand">{{item.title}}: {{props.row[item.prop]}}</div>
        </div>
      </template>
    </el-table-column>

    <!-- index -->

    <el-table-column type="index" width="55" v-if="config.base.showIndex == true">
    </el-table-column>

    <template v-for="field in config.field">

      <!-- normal -->

      <el-table-column
        v-if="field.tag == undefined"
        :fixed="field.fixed"
        :prop="field.id"
        :sortable="field.sortable == undefined ? false : field.sortable"
        :show-overflow-tooltip="field.tooltip"
        :label="field.text"
        :class-name="field.formatter == undefined ? '' : field.formatter"
        :formatter="field.formatter == undefined ? null : formatterFn"
        :width="field.width">
      </el-table-column>

      <!-- tag -->

      <el-table-column
        v-else
        :fixed="field.fixed"
        :sortable="field.sortable == undefined ? false : field.sortable"
        :show-overflow-tooltip="field.tooltip"
        :label="field.text"
        :width="field.width">
        <template scope="scope">
          <el-tag :type="field.tag.type" v-if="field.tag.not == undefined">{{scope.row[field.id]}}</el-tag>
          <el-tag :type="tagType(field, scope.row)" v-else>{{ tagText(field, scope.row) }}</el-tag>
        </template>
      </el-table-column>

    </template>
  
    <!-- opt column -->

    <el-table-column
      label="操作"
      :fixed="config.rowBtns.config.isFixed ? 'right' : false"
      :width="config.rowBtns.config.width"
      :context="_self"
      v-if="config.rowBtns !== false">
      <template scope="scope">
        <el-button
          v-for="btn in config.rowBtns.list"
          v-if="btn.sub == undefined"
          :plain="true"
          :icon="btn.icon"
          :type="btn.type"
          size="small"
          :disabled="btn.enabled != undefined && scope.row[btn.enabled.field] != btn.enabled.val"
          v-show="btnIsShow(btn, scope.row)"
          @click="clickRowBtn(btn, scope.row)">{{btn.text}}</el-button>
        <el-dropdown v-for="btn in config.rowBtns.list" v-if="btn.sub != undefined" trigger="hover">
          <el-button :type="btn.type" size="small" :plain="true">
            {{btn.text}}<i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="subBtn in btn.sub" @click.native="clickRowBtn(subBtn, scope.row)" v-show="btnIsShow(subBtn, scope.row)">{{subBtn.text}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-table-column>

  </el-table>

  <!-- page -->

  <div class="x-table-page" v-if="config.page != false">
    <el-pagination
      @size-change="pageChangeSize"
      @current-change="pageChange"
      :current-page="page.current"
      :page-sizes="page.sizes"
      :page-size="page.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total">
    </el-pagination>
  </div>
</div>

</template>

<script>
import ajax from './ajax'
import XselectRemote from './select_remote.vue'
import { formatterList } from 'src/config'

export default {
  name: 'xtable',
  props: ['config', 'data'],
  data() {
    return {
      loading: true,
      tableData: [],
      multiData: [],
      queryData: {},
      tableHeight: 0,
      multiOpt: false,
      page: {
        current: 1,
        sizes: [20, 50, 100],
        size: 20,
        total: 0
      },
      sort: {
        field: '',
        order: ''
      }
    }
  },
  created(){
    this.init();
    Date.prototype.Format = function (fmt) { //author: meizz 
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  methods: {
    tagType(field, row){
      if(field.tag.not.value instanceof Array){
        let re = false;
        for(let i in field.tag.not.value){
          if(field.tag.not.value[i] == row[field.id]){
            re = true;
            break;
          }
        }
        return re ? field.tag.not.type : field.tag.type;
      }else{
        return row[field.id] == field.tag.not.value ? field.tag.not.type : field.tag.type;
      }
    },
    tagText(field, row){
      if(field.tag.not.value instanceof Array){
        let re = false;
        for(let i in field.tag.not.value){
          if(field.tag.not.value[i] == row[field.id]){
            re = true;
            break;
          }
        }
        return re ? field.tag.not.text : field.tag.text;
      }else{
        return row[field.id] == field.tag.not.value ? field.tag.not.text: field.tag.text;
      }
    },
    btnIsShow(btn, row) {
      if(btn.show == undefined){
        return true;
      }else{
        if(btn.show.type == undefined){
          return row[btn.show.field] == btn.show.val ? true : false;
        }else if(btn.show.type == 'uneq'){
          if(typeof(btn.show.val) == 'object'){
            let rowValue = row[btn.show.field]
            if(!isNaN(row[btn.show.field]*1)){
              rowValue = row[btn.show.field]*1;
            }
            return btn.show.val.indexOf(rowValue) >= 0 ? false : true;
          }else{
            return row[btn.show.field] != btn.show.val ? true : false;
          }
        }
      }
    },
    init() {
      if(this.config.base.height == undefined){
        let contentHeight = document.body.clientHeight;
        let h = contentHeight;
        if(this.config.page !== false){
          h = h - 53;
        }
        if(this.config.query !== false){
          h = h - 60;
        }
        h = h - 140;
        this.tableHeight = h;
      }else{
        this.tableHeight = this.config.base.height;
      }

      if(this.config.query !== false){
        this.queryData = this.config.query.data;
      }
      if(this.config.page !== true){
        this.page.sizes = this.config.page.sizes;
        this.page.size = this.config.page.size;
      }
      this.getData();
    },
    getData() {
      let query = {};
      let queryPage = {};
      let querySort = {};
      if(this.config.page != false){
        queryPage = {
          page: this.page.current,
          pageSize: this.page.size
        }
      }
      querySort = {
        sortField: this.sort.field,
        sortOrder: this.sort.order
      }
      query = Object.assign(queryPage, querySort, this.queryData);
      this.loading = true;
      if(typeof(this.data) == 'object'){
        this.tableDate = this.data;
        this.page.total = this.tableData.length;
        this.loading = false;
      }else if(typeof(this.data) == 'string'){
        for(let i in this.config.query.form){
          if(this.config.query.form[i].type == 'date'){
            if(query[this.config.query.form[i].id]){
              let t = new Date(query[this.config.query.form[i].id]);
              query[this.config.query.form[i].id] = t.Format("yyyy-MM-dd");
            }
          }
        }
        let _self = this;
        ajax(this, 'get', this.data, query, (res) => {
          _self.tableData = res.data.list;
          _self.page.total = res.data.total;
          _self.$emit('getDataBack', res.data);
        }, () => {
          _self.loading = false;
        })
      }
    },
    pageChangeSize(val) {
      this.page.size = val;
      this.getData();
    },
    pageChange(val) {
      this.page.current = val;
      this.getData();
    },
    selectionChange(val) {
      this.multiData = val;
      this.multiOpt = val.length > 0 ? true : false;
    },
    sortTable(sorter) {
      this.sort.field = sorter.prop;
      this.sort.order = sorter.order;
      if(sorter.order == 'descending'){
        this.sort.order = 'desc';
      }else if(sorter.order == 'ascending'){
        this.sort.order = 'asc'
      }
      this.getData();
    },
    clickRowBtn(btn, row) {
      if(btn.ajax == undefined){
        this.$emit('clickRowBtn',btn, row);
      }else{
        let _self = this;
        let runAjax = () => {
          _self.loading = true;
          let param = {};
          for(let i in btn.ajax.param){
            let paramField = btn.ajax.param[i];
            param[paramField] = row[paramField];
          }
          if(btn.ajax.paramCustom != undefined){
            param = Object.assign(param, btn.ajax.paramCustom);
          }
          ajax(_self, 'post', btn.ajax.url ,param, (res) => {
            _self.$message({
              type: 'success',
              showClose: true,
              message: '操作成功!'
            });
            this.getData();
          }, () => {
            _self.loading = false;
          })
        }
        if(btn.ajax.confirm != false){
          this.$confirm(btn.ajax.confirm, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            runAjax();
          }).catch(() => {
                     
          });
        }else{
          runAjax();
        }
      }
    },
    clickMultiBtn(btn) {
      if(btn.ajax == undefined){
        this.$emit('clickMultiBtn',btn, this.multiData);
      }else{
        let _self = this;
        let runAjax = () => {
          _self.loading = true;
          let param = {};
          let paramStr = '';
          for(let i in this.multiData){
            paramStr = paramStr + this.multiData[i][btn.ajax.param];
            paramStr = paramStr + ',';
          }
          paramStr = paramStr.substr(0, paramStr.length - 1);
          param[btn.ajax.param] = paramStr;
          if(btn.ajax.paramCustom != undefined){
            param = Object.assign(param, btn.ajax.paramCustom);
          }
          ajax(_self, 'post', btn.ajax.url, param, (res) => {
            _self.$message({
              type: 'success',
              showClose: true,
              message: '操作成功!'
            });
            this.getData();
          }, () => {
            _self.loading = false;
          })
        }
        if(btn.ajax.confirm != false){
          this.$confirm(btn.ajax.confirm, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            runAjax();
          }).catch(() => {
                     
          });
        }else{
          runAjax();
        }
      }
    },
    formatterFn(row, column) {
      let re = '';
      for(let i in formatterList){
        if(column.property == formatterList[i].field && column.className == formatterList[i].type){
          for(let n in formatterList[i].render){
            let f = row[formatterList[i].field];
            f = isNaN(parseInt(f, 10)) ? f : f*1;
            if(f == formatterList[i].render[n].key){
              return formatterList[i].render[n].value;
            }
          }
        }
      }
    }
  },
  components: {
    XselectRemote
  }
}
</script>


// WEBPACK FOOTER //
// table.vue?2bdd7411